import React from 'react';
import { CheckCircle2Icon, FileTextIcon, AlertCircleIcon } from 'lucide-react';
const BidManagement = () => {
  return <div id="optimization" className="relative py-20 bg-gray-50 overflow-hidden" data-id="element-24">
      <div className="relative px-4 sm:px-6 lg:px-8" data-id="element-25">
        <div className="max-w-7xl mx-auto" data-id="element-26">
          <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-27">
            {/* Text Content */}
            <div className="lg:w-1/2" data-id="element-28">
              <h2 className="text-sm text-accentwarm font-bold tracking-widest uppercase" data-id="element-29">
                Content Optimization
              </h2>
              <h3 className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-customblack sm:text-4xl" data-id="element-30">
                Optimize Content for AI Discovery
              </h3>
              <p className="mt-4 text-lg text-customgray" data-id="element-31">
                Steward analyzes what AI engines look for and helps you create
                content that gets cited in AI-generated answers.
              </p>
              <div className="mt-8" data-id="element-32">
                <ul className="space-y-5" data-id="element-33">
                  {['AI-powered content recommendations based on engine preferences', 'Schema markup and structured data optimization', 'FAQ and answer-format content generation', 'Content gap analysis across AI search results'].map((item, i) => <li key={i} className="flex items-start" data-id="element-34">
                      <div className="flex-shrink-0 mt-0.5" data-id="element-35">
                        <CheckCircle2Icon className="h-5 w-5 text-accentwarm" aria-hidden="true" data-id="element-36" />
                      </div>
                      <p className="ml-3 text-base text-customgray font-medium" data-id="element-37">
                        {item}
                      </p>
                    </li>)}
                </ul>
              </div>
            </div>

            {/* Mockup */}
            <div className="lg:w-1/2 w-full" data-id="element-38">
              <div className="relative mx-auto w-full max-w-lg rounded-2xl bg-surface border border-gray-800 shadow-2xl overflow-hidden" data-id="element-39">
                {/* Mockup Header */}
                <div className="bg-primary/80 border-b border-gray-800 px-6 py-5 flex justify-between items-center" data-id="element-40">
                  <div data-id="element-41">
                    <h4 className="text-white font-semibold flex items-center" data-id="element-42">
                      <FileTextIcon className="w-4 h-4 mr-2 text-textlight" data-id="element-43" />
                      Page Analysis
                    </h4>
                    <p className="text-xs text-textlight mt-1 truncate max-w-[200px]" data-id="element-44">
                      /blog/what-is-aeo-marketing
                    </p>
                  </div>
                  <div className="text-right" data-id="element-45">
                    <div className="text-xs text-textlight mb-1 uppercase tracking-wider" data-id="element-46">
                      Content Score
                    </div>
                    <div className="text-3xl font-bold text-accentwarm" data-id="element-47">
                      87
                      <span className="text-sm text-gray-500 font-normal" data-id="element-48">
                        /100
                      </span>
                    </div>
                  </div>
                </div>

                {/* Mockup Content */}
                <div className="p-6 space-y-3 bg-gradient-to-b from-surface to-primary/30" data-id="element-49">
                  <h5 className="text-xs font-semibold text-textlight uppercase tracking-wider mb-4" data-id="element-50">
                    Optimization Suggestions
                  </h5>

                  {/* Suggestion 1 */}
                  <div className="flex items-center justify-between p-3 rounded-lg bg-primary/50 border border-gray-700" data-id="element-51">
                    <div className="flex items-center space-x-3" data-id="element-52">
                      <CheckCircle2Icon className="w-5 h-5 text-green-500" data-id="element-53" />
                      <span className="text-sm text-gray-300" data-id="element-54">
                        Add FAQ Schema Markup
                      </span>
                    </div>
                    <span className="text-xs text-green-500 bg-green-500/10 px-2 py-1 rounded" data-id="element-55">
                      Completed
                    </span>
                  </div>

                  {/* Suggestion 2 */}
                  <div className="flex items-center justify-between p-3 rounded-lg bg-primary/50 border border-gray-700" data-id="element-56">
                    <div className="flex items-center space-x-3" data-id="element-57">
                      <CheckCircle2Icon className="w-5 h-5 text-green-500" data-id="element-58" />
                      <span className="text-sm text-gray-300" data-id="element-59">
                        Format H2s as direct questions
                      </span>
                    </div>
                    <span className="text-xs text-green-500 bg-green-500/10 px-2 py-1 rounded" data-id="element-60">
                      Completed
                    </span>
                  </div>

                  {/* Suggestion 3 */}
                  <div className="flex items-center justify-between p-3 rounded-lg bg-accentwarm/10 border border-accentwarm/30" data-id="element-61">
                    <div className="flex items-center space-x-3" data-id="element-62">
                      <AlertCircleIcon className="w-5 h-5 text-accentwarm" data-id="element-63" />
                      <span className="text-sm text-white font-medium" data-id="element-64">
                        Include concise summary paragraph
                      </span>
                    </div>
                    <button className="text-xs bg-accentwarm text-primary font-medium px-3 py-1 rounded hover:bg-yellow-400 transition-colors" data-id="element-65">
                      Fix Now
                    </button>
                  </div>

                  {/* Suggestion 4 */}
                  <div className="flex items-center justify-between p-3 rounded-lg bg-primary/50 border border-gray-700" data-id="element-66">
                    <div className="flex items-center space-x-3" data-id="element-67">
                      <div className="w-5 h-5 rounded-full border-2 border-gray-600" data-id="element-68"></div>
                      <span className="text-sm text-gray-300" data-id="element-69">
                        Cite authoritative sources
                      </span>
                    </div>
                    <span className="text-xs text-textlight" data-id="element-70">+5 pts</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default BidManagement;